/** FNV-1a: a stable 32-bit number for a string, so the same event always draws the same. */
export function hashString(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Mulberry32: a small seeded random source, 0 (inclusive) to 1 (exclusive). */
export function seededRandom(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** The seed every effect uses: the event name, trimmed and case-folded, so a stray space doesn't move the terrain. */
export function effectSeed(eventName: string | null | undefined): string {
  return (eventName ?? '').trim().replace(/\s+/g, ' ').toLowerCase() || 'fitvent';
}
